const UPLOAD_REQUEST = 'UPLOAD_REQUEST'
const UPLOAD_REQUESTING = 'UPLOAD_REQUESTING'
const UPLOAD_PROGRESS = 'UPLOAD_PROGRESS'
const UPLOAD_SUCCESS = 'UPLOAD_SUCCESS'
const UPLOAD_FAILURE = 'UPLOAD_FAILURE'
const UPLOAD_FINISHED = 'UPLOAD_FINISHED'
const UPLOAD_SELECT_CATEGORY = 'UPLOAD_SELECT_CATEGORY'
const UPLOAD_DELETE = 'UPLOAD_DELETE'
const UPLOAD_CLEAR = 'UPLOAD_CLEAR'
const UPLOAD_CLEAR_MOST = 'UPLOAD_CLEAR_MOST'
const UPLOAD_SELECT_HANDLER = 'UPLOAD_SELECT_HANDLER'
const ATTACH_FILES_TO_STATE = 'ATTACH_FILES_TO_STATE'
const SAVE_IMAGE_PREVIEW = 'SAVE_IMAGE_PREVIEW'
const DISPLAY_IN_MODAL = 'DISPLAY_IN_MODAL'
const TOGGLE_CATEGORY_PREVIEW = 'TOGGLE_CATEGORY_PREVIEW'
const SHOW_ALL_CATEGORIES = 'SHOW_ALL_CATEGORIES'
const FIND_AUTHUNAUTH = 'FIND_AUTHUNAUTH'
const ON_TRACKING_ERROR = 'ON_TRACKING_ERROR'

/** error managment */
const ADD_ERROR = 'ADD_ERROR'
const CLEAR_ERROR = 'CLEAR_ERROR'
const CLEAR_ALL_ERRORS = 'CLEAR_ALL_ERRORS'

// error categories
const EXCEEDED_MAX = 'EXCEEDED_MAX'
const EXCEEDED_MAX_QTY = 'EXCEEDED_MAX_QTY'
const EXCEEDED_MAX_CUMULATIVE = 'EXCEEDED_MAX_CUMULATIVE'
const REJECTED = 'REJECTED'
const MISSING_CATEGORY = 'MISSING_CATEGORY'

const MAX_UPLOAD_SIZE = 30000000
const MAX_QUANTITY = 50

const categories = [
  { rank: 0, value: 'damageAutoHomeBus', display: 'Photo/video of damage' },
  { rank: 1, value: 'medicalBillsReports', display: 'Medical Bills with/without Reports' },
  { rank: 2, value: 'medicalReportsOnly', display: 'Medical Reports only' },
  { rank: 3, value: 'nonmedInvoices', display: 'Non-medical Invoices' },
  { rank: 4, value: 'estimatesAppraisals', display: 'Appraisals or Estimates' },
  { rank: 5, value: 'lossLocationScene', display: 'Photo/video of loss location' },
  { rank: 6, value: 'receiptsReimbursements', display: 'Receipt/Proof of Reimbursement' },
  { rank: 7, value: 'letterOrStateForm', display: 'Forms (Title, direction to pay, etc.)' },
  { rank: 8, value: 'wageInformation', display: 'Wage Information' },
  { rank: 9, value: 'other', display: 'Other' }
]

const roleMedical = [
  'travelersPolicyHolder',
  'claimant',
  'employee',
  'legalRep',
  'agentBroker',
  'other',
  'otherCarrier'
]
const categoriesMedical = [
  'medicalBillsReports',
  'medicalReportsOnly',
  'receiptsReimbursements',
  'other'
]
const roleAutoAppraisal = [
  'travelersPolicyHolder',
  'claimant',
  'employee',
  'repairCont',
  'legalRep',
  'agentBroker',
  'other'
]
const cookiesToKeep = [
  'TravSessionId',
  'Trv-Session-Id',
  'TravAuthE',
  'TravAuthV',
  'TrvAuthToken'
]

export {
  ADD_ERROR,
  ATTACH_FILES_TO_STATE,
  categories,
  categoriesMedical,
  CLEAR_ALL_ERRORS,
  CLEAR_ERROR,
  cookiesToKeep,
  DISPLAY_IN_MODAL,
  EXCEEDED_MAX,
  EXCEEDED_MAX_CUMULATIVE,
  EXCEEDED_MAX_QTY,
  FIND_AUTHUNAUTH,
  MAX_QUANTITY,
  MAX_UPLOAD_SIZE,
  MISSING_CATEGORY,
  ON_TRACKING_ERROR,
  REJECTED,
  roleAutoAppraisal,
  roleMedical,
  SAVE_IMAGE_PREVIEW,
  SHOW_ALL_CATEGORIES,
  TOGGLE_CATEGORY_PREVIEW,
  UPLOAD_CLEAR,
  UPLOAD_CLEAR_MOST,
  UPLOAD_DELETE,
  UPLOAD_FAILURE,
  UPLOAD_FINISHED,
  UPLOAD_PROGRESS,
  UPLOAD_REQUEST,
  UPLOAD_REQUESTING,
  UPLOAD_SELECT_CATEGORY,
  UPLOAD_SELECT_HANDLER,
  UPLOAD_SUCCESS
}
